<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 text-xs-left px-4>
        <v-checkbox
          v-model="mainSystemPeriod"
          label="Utilizar período padrão do sistema de janeiro a dezembro"
          color="primary"
          hide-details
        ></v-checkbox>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 text-xs-left px-4>
        <div class="caption text-xs-left pb-3 mx-1 pt-1">
          O sitema utilizará automaticamente o período contabíl padrão, mas você
          pode criar períodos diferenciados para cada ano de vigência.
        </div>
      </v-flex>
    </v-layout>
    <PostingPeriodForm
      v-if="!disableFields"
      :editData="editData"
      :postingPeriodDialogShow="postingPeriodDialogShow"
      :closeForm="closeForm"
      :openForm="openForm"
      :updatePostingPeriod="updatePostingPeriod"
    />
    <v-data-table
      class="mt-3"
      no-data-text="Não há períodos contábeis cadastrados"
      :headers="headers"
      :items="accounting_year"
      rows-per-page-text="Linhas por página"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon color="success" v-if="props.item.status">check_circle</v-icon>
          <v-icon color="error" v-if="!props.item.status">block</v-icon>
        </td>
        <td class="text-xs-center">{{ props.item.year }}</td>
        <td class="text-xs-center">
          {{ props.item.date_init | moment("MM/YYYY") }}
        </td>
        <td class="text-xs-center">
          {{ props.item.date_end | moment("MM/YYYY") }}
        </td>
        <td class="text-xs-center layout">
          <template v-if="!disableFields">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon
              v-if="!props.item.status"
              small
              class="mr-2"
              @click="confirmToogleStatusItem(props.item)"
              >check</v-icon
            >
            <v-icon
              v-if="props.item.status"
              small
              class="mr-2"
              @click="confirmToogleStatusItem(props.item)"
              >block</v-icon
            >
            <v-icon small @click="confirmDelPostingPeriod(props.item)"
              >delete</v-icon
            >
          </template>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PostingPeriodForm from './PostingPeriodForm'

export default {
  name: 'PostingPeriod',

  props: {
    disableFields: { type: Boolean, default: false },
    forwShow: Boolean,
    accounting_year: Array,
    updatePostingPeriod: Function,
    confirmDelPostingPeriod: Function,
    confirmToogleStatusItem: Function
  },

  components: {
    PostingPeriodForm
  },

  data () {
    return {
      editData: {},
      headers: [
        {
          text: 'Status',
          align: 'center',
          value: 'active',
          sortable: false
        },
        {
          text: 'Ano de vigência',
          value: 'year',
          align: 'center',
          sortable: false
        },
        {
          text: 'Data inicial',
          value: 'date_init',
          align: 'center',
          sortable: false
        },
        {
          text: 'Data final',
          value: 'date_end',
          align: 'center',
          sortable: false
        },
        { text: 'Ações', value: '', sortable: false, align: 'left' }
      ],
      // accounting_year: [],
      postingPeriodDialogShow: false,
      mainSystemPeriod: false
    }
  },

  watch: {
    forwShow (v) {
      if (v) {
        if (this.accounting_year.length) {
          this.mainSystemPeriod = false
        } else {
          this.mainSystemPeriod = true
        }
      }
    }
    // accounting_year.length
  },

  methods: {
    updateGrid (data) {
      // this.accounting_year = [...data];
      this.mainSystemPeriod = false
      this.postingPeriodDialogShow = false
    },

    editItem (data) {
      data.editing = true
      this.editData = { ...data }
      this.openForm('editing')
    },

    // confirmToogleStatusItem() {},
    openForm (edit) {
      if (edit !== 'editing') {
        this.editData = {}
      }
      this.postingPeriodDialogShow = true
    },

    closeForm (edit) {
      this.mainSystemPeriod = false
      this.editData = {}
      this.postingPeriodDialogShow = false
    }
  }
}
</script>

<style>
</style>
